export function bookingFlow(booking, currentPage) {
  // currentPage
  // 0. Booking Form
  // 1. Customer Assessment
  // 2. Payment
  // 3. Loan Tracker
  let hasCustomerAssessment = false;
  let hasPayment = false;
  let hasLoanTracker = false;
  let sofGroup = 0;
  if (booking && booking.project) {
    const project = booking.project;
    const sof = booking.paymentMethodID;
    if (project.customerAssessmentFlow) hasCustomerAssessment = true;
    if (project.paymentFlow) hasPayment = true;
    if (project.loanTrackerDirectShow) hasLoanTracker = true;
    if (sof === 'referred_banker' || sof === 'own_banker') sofGroup = 1;
    if (sof === 'government_loan') sofGroup = 2;
    if (sof === 'cash' || sof === 'staff_loan') sofGroup = 3;
    if (sof !== 'cash') sofGroup = 4;
  }

  function switchURL(page) {
    const nextURL = `/bookings/${booking.id}/`;
    if (page === 0) {
      if (hasCustomerAssessment && sofGroup === 1) return `${nextURL}credit_check/`;
      if (hasCustomerAssessment && sofGroup === 2) return `${nextURL}lppsa/`;
      return switchURL(1);
    } else if (page === 1) {
      if (hasPayment) return `${nextURL}payment/`;
      return switchURL(2);
    } else if (page === 2) {
      if (hasLoanTracker && sofGroup === 4 && !booking.buyerProfileID) return `${nextURL}loan/`;
    }
    return nextURL;
  }
  return switchURL(currentPage);
}



// WEBPACK FOOTER //
// ./src/utils/routes.js